import { InterviewStatusEnum } from '@/types/graphql';

export const parseInterViewQuestionarieStatus = (
  status: InterviewStatusEnum | null
) => {
  if (status === null) {
    return 'To Review';
  }

  return (
    {
      [InterviewStatusEnum.INTERVIEW_DECLINED]: 'Declined',
      [InterviewStatusEnum.INTERVIEW_PASSED]: 'Passed',
    }[status] || 'To Review'
  );
};
